// extracted by mini-css-extract-plugin
export var marginBottom = "ContentWrap-module--marginBottom--0c067";
export var maxWidth = "ContentWrap-module--maxWidth--8eff6";
export var normal = "ContentWrap-module--normal--5853a";
export var root = "ContentWrap-module--root--c3ebd";
export var thin = "ContentWrap-module--thin--0c839";
export var wide = "ContentWrap-module--wide--8605b";